import { Item } from './item.model';
import { Modifier } from './modifier.model';
import { RangeColor } from './range.model';
import { WeaponDamage, WeaponRange } from './weapon.model';

export interface Equipment extends Item {
    _id: string;
    id: number;
    name: string;
    wave: number;
    image: string;
    canBePickedUp: boolean;
    subTypes?: string[];
    armourType?: 'BASE' | 'MOD' | 'POWER';
    category: string;
    battleModeCategory: string;
    groupName?: string;
    skillDescription?: string;
    reloaded: boolean;
    critPoints: number;
    multi: boolean;
    primed: boolean;
    mod: Modifier[];
    onUse?: any;
    pickedUpDuringBattle?: boolean;
    damaged: boolean;
    packs: string[];
    equipped?: boolean;
    hide?: boolean;
    questReward?: boolean;
    unique?: boolean;
    itemType: 'equipment';
    caps?: number;
    rpgOnly?: boolean;
    stats: {
        range?: { short?: WeaponRange; long?: WeaponRange };
        damage?: WeaponDamage;
        effects: string[];
        dice: string[];
        hideTypeIcon?: boolean;
        hideVaultBoy?: boolean;
        reload?: boolean;
        effectText: string;
        crit: {
            points: number;
            range?: string;
            dice: RangeColor[];
            damage: WeaponDamage;
            effects: string[];
        };
    };
    specialIcons?: string[];
}

export const EQUIPMENT_TYPES = [
    'ARMOR',
    'POWER ARMOR',
    'CLOTHING',
    'MELEE',
    'PISTOL',
    'RIFLE',
    'HEAVY WEAPON',
    'GRENADE',
    'MOD',
    'MINE',
    'CHEM',
    'FOOD',
    'DRINK',
    'UTILITY',
    'JUNK',
    'CREATURE ABILITY',
    'ROBOT'
];
